import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, mergeProps as _mergeProps, createElementVNode as _createElementVNode, createElementBlock as _createElementBlock, renderList as _renderList, Fragment as _Fragment, withModifiers as _withModifiers, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, resolveDirective as _resolveDirective, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = { key: 0 }
const _hoisted_2 = ["src"]
const _hoisted_3 = ["src"]
const _hoisted_4 = ["src"]
const _hoisted_5 = ["src"]
const _hoisted_6 = ["src"]
const _hoisted_7 = ["src"]
const _hoisted_8 = ["innerHTML"]
const _hoisted_9 = { class: "ml-2 mt-0 legendMapDash" }

import {
  Ref,
  computed,
  onMounted,
  ref,
  watch,
  onBeforeUnmount,
  toRaw,
} from "vue";
import type { PropType } from "vue";

/********************************
 ************ VUETIFY ***********
 *******************************/
import { useDisplay } from "vuetify";
import { useI18n } from "vue-i18n";
import { useStore } from "vuex";
import MessageComponent from "@/components/SmartLink/dashboard/MessageComponent.vue";
import DialogComponent from "@/components/SmartLink/dialog/dialogComponent.vue";
import rangeComponent from "@/components/SmartLink/dashboard/rangeComponent.vue";

/********************************
 *********** LEAFLET ************
 *******************************/
import {
  LMap,
  LTileLayer,
  LPolyline,
  LMarker,
  LIcon,
  LTooltip,
  LControlZoom,
  LControl,
} from "@vue-leaflet/vue-leaflet";
import "/public/leaflet/leaflet.css";
import L from "leaflet";
import "leaflet/dist/leaflet.css";
import "leaflet.heat";

/********************************
 ********** CONSTANTES **********
 *******************************/
import {
  LABELS,
  NAME_PROJECT,
  STRING_GENERAL,
} from "@/constants/labels";
import CONSTANTIMGS from "@/constants/images";
import { COLOR } from "@/constants/colors";
import CONSTMAPS from "@/constants/maps";

/********************************
 ********** INTERFACES **********
 *******************************/
import { POSITION, CIRCLE, CLUSTERING } from "@/interfaces/SmartLink/Map";
import { EQUIPAMENTS } from "@/interfaces/SmartLink/Equips";
import { STRINGS } from "@/interfaces/SmartLink/General";
import { PointExpression } from "leaflet";// NetworkChart.vue (<script setup lang="ts">)
import { ALARMTYPE } from "@/interfaces/SmartLink/KPI";

/********************************
 *********** UTILS **************
 *******************************/
import {
  getStatusByLatency,
  getStatusBySNR,
  getStatusByRXLVL,
  getFinalStatusByStatitics,
} from "@/functions/maps";

import {
  groupVisibleDevices,
  buildActiveLinks,
  NetworkDevice,
  ClusteredMarker,
} from "@/utils/SmartLink/mapClustering";

// --- PROPS CENTRALIZADAS (REEMPLAZAN LAS LLAMADAS A API) ---

export default /*@__PURE__*/_defineComponent({
  __name: 'NetworkChart',
  props: {
  latLngSm: { type: Array as PropType<EQUIPAMENTS[]>, default: () => [] },
  latLngRaj: { type: Array as PropType<EQUIPAMENTS[]>, default: () => [] },
  latLngAp: { type: Array as PropType<any[]>, default: () => [] },
  polylinesData: { type: Array as PropType<any[]>, default: () => [] },
  rxlvlSnrData: { type: Array as PropType<any[]>, default: () => [] },
  latencyData: { type: Array as PropType<any[]>, default: () => [] },
  hexagonData: { 
    type: [Object, null] as PropType<Record<string, any> | null>, 
    default: null 
  },
  recurrentAlarms: { type: Array as PropType<ALARMTYPE[]>, default: () => [] }
},
  setup(__props) {

const { smAndDown, mdAndDown } = useDisplay();

/********************************
 ************ I18N **************
 *******************************/
const { t } = useI18n();

/********************************
 ************ STORE *************
 *******************************/
const store = useStore();

/********************************
 ********** COMPONENTS **********
 *******************************/
if (typeof window !== "undefined") {
  window.L = L;
}
const props = __props;

// --- ESTADOS Y REACTIVIDAD ---
const active = ref(false);
const projectName = computed(() => store.state.projectName);
const isChile = ref(
  projectName.value === "SmartLinkAntucoya" ||
    projectName.value === "SmartLinkZaldivar",
);
const finalURL = ref("");
const width = ref("350");
const widthToolTip = ref("100");

const zoomMap = computed(() => CONSTMAPS.zoom.value);
const centerMap: Ref<PointExpression> = ref([
  CONSTMAPS.latitud.value,
  CONSTMAPS.longitud.value,
]);

// Controles de Visualización
const showALL = ref(true);
const showPMPAP = ref(true);
const showPMPSM = ref(true);
const showRajant = ref(true);
const showPolilynesBoolean = ref(true);
const showNames = ref(true);
const showCircleCluster = ref(true);
const showTimeLineClustering = ref(false);
const showFilters = ref(true);

// Diálogo
const dialog = ref(false);
const selectedIp = ref("");
const selectedName = ref("");
const selectedType = ref("");
const finalStatus = ref("Ok");

// Colección general de datos puros asignados desde las Props
const elementPMPSM = computed(() => props.latLngSm);
const elementRAJANT = computed(() => props.latLngRaj);
const rawPMPAPItems = computed(() => props.latLngAp);
const rawPolylinesList = computed(() => props.polylinesData);

// Colecciones consolidadas
const allNetworkDevices: Ref<NetworkDevice[]> = ref([]);
const renderClusters: Ref<ClusteredMarker[]> = ref([]);
const activePolylines: Ref<any[]> = ref([]);

const allFinalStatiticsItems: any = ref({});
const allFinalStatusItems: any = ref({});
const pointsClustering: Ref<CLUSTERING[]> = ref([]);
const valueSliderMap = ref(12);
const arrayDatesClustering: Ref<string[]> = ref([]);
const totalClusteringData: Ref<CLUSTERING[]> = ref([]);

const mapInstance: any = ref(null);
let heatLayer: any = null;
let geoJsonLayer: any = null;

const COLORSTATUS: STRINGS = {
  OK: "green",
  ALERT: "yellow",
  ALARM: "red",
  DOWN: "#353634",
};

watch(smAndDown, (valor: boolean) => {
  valor ? (width.value = "100%") : (width.value = "350");
});

// ================================================== //
// ================= CLUSTERING LOGIC =============== //
// ================================================== //

const updateMapVisualization = () => {
  if (!showALL.value) {
    renderClusters.value = [];
    activePolylines.value = [];
    return;
  }

  const visibleDevices = allNetworkDevices.value.filter((dev) => {
    if (dev.tipo === "PMPAP" && showPMPAP.value) return true;
    if (dev.tipo === "PMPSM" && showPMPSM.value) return true;
    if (dev.tipo === "RAJANT" && showRajant.value) return true;
    return false;
  });

  renderClusters.value = groupVisibleDevices(
    visibleDevices,
    0.0005,
    CONSTANTIMGS
  );

  if (showPolilynesBoolean.value) {
    activePolylines.value = buildActiveLinks(
      visibleDevices,
      rawPolylinesList.value
    );
  } else {
    activePolylines.value = [];
  }
};

watch(
  [showALL, showPMPAP, showPMPSM, showRajant, showPolilynesBoolean],
  () => {
    updateMapVisualization();
  },
  { deep: true },
);

// ================================================== //
// ================= PROCESAMIENTO DE DATOS ========= //
// ================================================== //

function getStatusByIP(ip: string) {
  if (!allFinalStatusItems.value[ip]) {
    return "down";
  }
  return allFinalStatusItems.value[ip].status;
}

function processRXLVLSNRData() {
  if (!props.rxlvlSnrData) return;
  props.rxlvlSnrData.forEach((item: any) => {
    if (allFinalStatiticsItems.value[item.ip]) {
      allFinalStatiticsItems.value[item.ip].snrv = getStatusBySNR(item.snrv);
      allFinalStatiticsItems.value[item.ip].snrh = getStatusBySNR(item.snrh);
      allFinalStatiticsItems.value[item.ip].rxlvlh = getStatusByRXLVL(item.rxlvlh);
      allFinalStatiticsItems.value[item.ip].rxlvlv = getStatusByRXLVL(item.rxlvlv);
      allFinalStatiticsItems.value[item.ip].snrvValue = item.snrv;
      allFinalStatiticsItems.value[item.ip].snrhValue = item.snrh;
      allFinalStatiticsItems.value[item.ip].rxlvlhValue = item.rxlvlh;
      allFinalStatiticsItems.value[item.ip].rxlvlvValue = item.rxlvlv;
    }
  });
}

function processLatencyData() {
  if (!props.latencyData) return;
  props.latencyData.forEach((item: any) => {
    if (!allFinalStatiticsItems.value[item.ip]) {
      allFinalStatiticsItems.value[item.ip] = {};
    }
    allFinalStatiticsItems.value[item.ip].latencia = getStatusByLatency(item.latencia);
    allFinalStatiticsItems.value[item.ip].latenciaValue = item.latencia;
    allFinalStatiticsItems.value[item.ip].fecha = item.fecha;
  });
}

const extractNumberFromName = (name: string, tipo: string): string => {
  if (!name) return "";

  if (
    projectName.value === NAME_PROJECT.cananea ||
    projectName.value === NAME_PROJECT.demo ||
    projectName.value === NAME_PROJECT.nacozari
  ) {
    if (tipo === "RAJANT") return name.split("-")[0] || "";
    if (tipo === "PMPSM") return name.split("M")[1] || "";
  }

  if (projectName.value === NAME_PROJECT.collahuasi) {
    if (tipo === "RAJANT") return name.split("-")[2] || "";
    if (tipo === "PMPSM") return name.split("-")[3] || "";
  }

  const match = name.match(/\d+/);
  return match ? match[0] : "";
};

const buildConsolidatedDevices = async () => {
  const list: NetworkDevice[] = [];
  const rajantCoordsByNumber = new Map<string, [number, number]>();

  elementRAJANT.value.forEach((element: EQUIPAMENTS) => {
    const rajNum = extractNumberFromName(element.name ?? "", "RAJANT");
    const lat = element.latitud ?? 0;
    const lng = element.longitud ?? 0;

    if (rajNum && (lat !== 0 || lng !== 0)) {
      rajantCoordsByNumber.set(rajNum, [lat, lng]);
    }

    list.push({
      ip: element.ip ?? "",
      name: element.name ?? "",
      tipo: "RAJANT",
      position: [lat, lng],
      status: getStatusByIP(element.ip ?? ""),
    });
  });

  elementPMPSM.value.forEach((pmpsm: EQUIPAMENTS) => {
    const smNum = extractNumberFromName(pmpsm.name ?? "", "PMPSM");
    let finalPosition: [number, number] = [
      pmpsm.latitud ?? 0,
      pmpsm.longitud ?? 0,
    ];

    let anotacion: any = pmpsm.anotacion !== null ? pmpsm.anotacion ?? {} : {};
    
    if (anotacion.gps) {
      const matchRaj = elementRAJANT.value.find((r) => r.ip === anotacion.gps);
      if (matchRaj) {
        finalPosition = [matchRaj.latitud ?? 0, matchRaj.longitud ?? 0];
      }
    } else if (smNum && rajantCoordsByNumber.has(smNum)) {
      finalPosition = rajantCoordsByNumber.get(smNum)!;
    }

    list.push({
      ip: pmpsm.ip ?? "",
      name: pmpsm.name ?? "",
      tipo: "PMPSM",
      position: finalPosition,
      status: getStatusByIP(pmpsm.ip ?? ""),
    });
  });

  rawPMPAPItems.value.forEach((element: EQUIPAMENTS) => {
    let finalLat = element.gps?.latitud ?? element.latitud ?? 0;
    let finalLng = element.gps?.longitud ?? element.longitud ?? 0;

    if (
      element.name?.includes(STRING_GENERAL.PMPAP1) ||
      element.name?.includes(STRING_GENERAL.PMPAP5)
    ) {
      finalLat = (element.longitud ?? 0) + 0.000512;
      finalLng = (element.latitud ?? 0) - 0.000512;
    }

    list.push({
      ip: element.ip ?? "",
      name: element.name ?? "",
      tipo: "PMPAP",
      position: [finalLat, finalLng],
      status: getStatusByIP(element.ip ?? ""),
    });
  });

  allNetworkDevices.value = list;
};

async function processAllMapInfo() {
  allFinalStatiticsItems.value = {};
  processLatencyData();
  processRXLVLSNRData();
  allFinalStatusItems.value = await getFinalStatusByStatitics(
    allFinalStatiticsItems.value,
  );
  await buildConsolidatedDevices();
  updateMapVisualization();
}

// Reactividad directa en respuesta a la orquestación central
watch(
  () => [props.latLngSm, props.latLngRaj, props.latencyData, props.rxlvlSnrData],
  async () => {
    await processAllMapInfo();
  },
  { deep: true, immediate: true }
);

// ================================================== //
// ================= MAP HELPERS & UI =============== //
// ================================================== //

const onClickOutside = () => (active.value = false);
const activeClick = () => (active.value = true);

const onMapReady = (mapObject: any) => {
  mapInstance.value = mapObject;
};

function getInfoInToMap(ip: string) {
  const itemData = allFinalStatiticsItems.value[ip];

  if (!itemData) {
    return `<p>Sin datos de métricas</p>`;
  }

  let htmlInMap = "";

  const isValidMetric = (val: any): boolean => {
    return val !== undefined && val !== null && val !== "" && !isNaN(Number(val));
  };

  if (isValidMetric(itemData.latenciaValue)) {
    htmlInMap += `<p>Latencia : ${itemData.latenciaValue} ms</p>`;
  }
  if (isValidMetric(itemData.rxlvlhValue)) {
    htmlInMap += `<p>RXLVL-H : ${itemData.rxlvlhValue} dBm</p>`;
  }
  if (isValidMetric(itemData.rxlvlvValue)) {
    htmlInMap += `<p>RXLVL-V : ${itemData.rxlvlvValue} dBm</p>`;
  }
  if (isValidMetric(itemData.snrhValue)) {
    htmlInMap += `<p>SNRH : ${itemData.snrhValue} dB</p>`;
  }
  if (isValidMetric(itemData.snrvValue)) {
    htmlInMap += `<p>SNRV : ${itemData.snrvValue} dB</p>`;
  }

  if (htmlInMap === "") {
    htmlInMap = `<p>Sin información disponible</p>`;
  }

  return htmlInMap;
}

const getColorSheet = (status: string) => {
  const st = (status || "").toUpperCase();
  if (st === "OK") return "green";
  if (st === "ALERT") return "yellow";
  if (st === "ALARM") return "red";
  return "#505150";
};

const getColorCard = (status: string) => {
  const st = (status || "").toUpperCase();
  if (st === "OK") return "greenSheet";
  if (st === "ALERT") return "yellowSheet";
  if (st === "ALARM") return "redSheet";
  return "greySheet";
};

const showDialog = (
  ip: string,
  type: string,
  name: string,
  status: string,
) => {
  dialog.value = !dialog.value;
  selectedName.value = name;
  selectedIp.value = ip;
  selectedType.value = type;
  finalStatus.value = status;
};

const closeDialog = (value: boolean) => {
  dialog.value = value;
};

const onDeviceClick = (device: NetworkDevice) => {
  showDialog(device.ip, device.tipo, device.name, device.status);
};

const changezoom = (e: number) => store.commit("setProjectZOOM", e);
const changeCenter = (center: any) => {
  store.commit("setProjectLAT", center.lat);
  store.commit("setProjectLNG", center.lng);
};

// Heatmap y Hexagon
const actualizarHeatmap = async () => {
  if (!mapInstance.value) return;
  const map: any = toRaw(mapInstance.value);
  if (heatLayer) map.removeLayer(heatLayer);

  const puntosCalor: any[] = [];
  pointsClustering.value.forEach((p: any) => {
    if (p.latitud !== 0 && p.longitud !== 0) {
      puntosCalor.push([p.latitud, p.longitud, 0.3]);
    }
  });

  heatLayer = L.heatLayer(puntosCalor, {
    radius: 17,
    blur: 2,
    maxZoom: 15,
    gradient: { 0.6: "yellow", 1: "red" },
  });

  map.addLayer(heatLayer);
};

watch(pointsClustering, () => actualizarHeatmap(), { deep: true });

function renderHexagonInMap() {
  if (!props.hexagonData) return;
  if (geoJsonLayer && mapInstance.value) {
    mapInstance.value.removeLayer(geoJsonLayer);
  }
  
  geoJsonLayer = L.geoJSON(props.hexagonData as any, {
    style: (feature: any) => ({
      color: "white",
      weight: 1,
      fillColor: feature.properties.color,
      fillOpacity: 0.6,
    }),
    onEachFeature: (feature: any, layer: any) => {
      const p = feature.properties;
      const popupContent = `
        <div style="text-align:center">
          <h3 style="margin:0; color:${p.color}">Zona ${p.tasaFallo} Fallo</h3>
          <hr style="margin:5px 0">
          <b>Muestras:</b> ${p.muestras}<br>
          <b>Fallos:</b> ${p.fallos}<br>
        </div>`;
      layer.bindPopup(popupContent);
    },
  });

  if (mapInstance.value && showCircleCluster.value) {
    geoJsonLayer.addTo(mapInstance.value);
  }
}

watch(() => props.hexagonData, () => renderHexagonInMap(), { immediate: true });

watch(showCircleCluster, (value: boolean) => {
  if (geoJsonLayer && mapInstance.value) {
    if (value) {
      geoJsonLayer.addTo(mapInstance.value);
    } else {
      mapInstance.value.removeLayer(geoJsonLayer);
    }
  }
});

const season = (val: number) => arrayDatesClustering.value[val - 1];
const addHours = () => {
  if (valueSliderMap.value < 12) valueSliderMap.value++;
};
const deleteHours = () => {
  if (valueSliderMap.value > 1) valueSliderMap.value--;
};

onMounted(async () => {
  finalURL.value =
    "https://server.arcgisonline.com/ArcGIS/rest/services/World_Imagery/MapServer/tile/{z}/{y}/{x}";
  await processAllMapInfo();
});

onBeforeUnmount(() => {
  if (mapInstance.value && heatLayer) {
    const map: any = toRaw(mapInstance.value);
    map.removeLayer(heatLayer);
  }
});

return (_ctx: any,_cache: any) => {
  const _component_v_sheet = _resolveComponent("v-sheet")!
  const _component_v_slider = _resolveComponent("v-slider")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_checkbox = _resolveComponent("v-checkbox")!
  const _component_v_row = _resolveComponent("v-row")!
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_menu = _resolveComponent("v-menu")!
  const _component_v_divider = _resolveComponent("v-divider")!
  const _component_v_dialog = _resolveComponent("v-dialog")!
  const _directive_click_outside = _resolveDirective("click-outside")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_v_sheet, {
      class: "cardDashboard",
      color: "transparent"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_v_row, { class: "ma-0" }, {
          default: _withCtx(() => [
            _createElementVNode("div", {
              style: _normalizeStyle(`${
          _unref(mdAndDown) ? 'width: 100%' : `width: calc(100% - ${width.value}px);`
        }`)
            }, [
              (showTimeLineClustering.value)
                ? (_openBlock(), _createBlock(_component_v_slider, {
                    key: 0,
                    modelValue: valueSliderMap.value,
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((valueSliderMap).value = $event)),
                    max: 12,
                    min: 1,
                    step: 1,
                    "thumb-label": "always",
                    class: "mt-6",
                    "append-icon": "mdi-plus",
                    "prepend-icon": "mdi-minus",
                    "onClick:append": addHours,
                    "onClick:prepend": deleteHours
                  }, {
                    "thumb-label": _withCtx(({ modelValue }) => [
                      _createVNode(_component_v_sheet, {
                        color: "transparent",
                        width: "150"
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(season(modelValue)), 1)
                        ]),
                        _: 2
                      }, 1024)
                    ]),
                    _: 1
                  }, 8, ["modelValue"]))
                : _createCommentVNode("", true),
              _withDirectives((_openBlock(), _createElementBlock("div", {
                class: "mapContainer",
                style: `height:750px `,
                onClick: activeClick
              }, [
                _createVNode(_unref(LMap), {
                  ref: "mapRef",
                  class: "mapClassBorder",
                  style: _normalizeStyle(
              !active.value ? 'border: 0px solid white' : 'border: 4px solid white'
            ),
                  zoom: zoomMap.value,
                  center: centerMap.value,
                  "onUpdate:zoom": _cache[9] || (_cache[9] = ($event: any) => (changezoom($event))),
                  "onUpdate:center": _cache[10] || (_cache[10] = ($event: any) => (changeCenter($event))),
                  onReady: onMapReady,
                  options: { zoomControl: false }
                }, {
                  default: _withCtx(() => [
                    _createVNode(_unref(LControlZoom), { position: 'topleft' }),
                    _createVNode(_unref(LControl), { position: "topright" }, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_menu, {
                          "close-on-content-click": false,
                          location: "end"
                        }, {
                          activator: _withCtx(({ props }) => [
                            _createVNode(_component_v_sheet, { class: "iconMapButton" }, {
                              default: _withCtx(() => [
                                _createVNode(_component_v_btn, _mergeProps({
                                  color: "black",
                                  variant: "text",
                                  icon: "mdi-menu"
                                }, props), null, 16)
                              ]),
                              _: 2
                            }, 1024)
                          ]),
                          default: _withCtx(() => [
                            _createVNode(_component_v_sheet, {
                              width: "300",
                              "max-height": "550",
                              color: "bgtopology",
                              class: "datepickerContainer"
                            }, {
                              default: _withCtx(() => [
                                (!isChile.value)
                                  ? (_openBlock(), _createBlock(_component_v_row, {
                                      key: 0,
                                      class: "ma-2 mb-3"
                                    }, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_v_col, {
                                          class: "pa-0",
                                          cols: "12",
                                          sm: "4",
                                          md: "12"
                                        }, {
                                          default: _withCtx(() => [
                                            _createVNode(_component_v_row, { class: "ma-0 my-2" }, {
                                              default: _withCtx(() => [
                                                _createVNode(_component_v_sheet, {
                                                  class: "rowIcon pl-2 pt-0",
                                                  color: "transparent",
                                                  height: "40",
                                                  width: "40"
                                                }, {
                                                  default: _withCtx(() => [
                                                    _createVNode(_component_v_sheet, {
                                                      class: "sheetNameIcon pb-1",
                                                      width: "25",
                                                      height: "25"
                                                    }, {
                                                      default: _withCtx(() => [
                                                        _createVNode(_component_v_icon, {
                                                          size: "small",
                                                          color: "white"
                                                        }, {
                                                          default: _withCtx(() => [...(_cache[12] || (_cache[12] = [
                                                            _createTextVNode("mdi-eye", -1)
                                                          ]))]),
                                                          _: 1
                                                        })
                                                      ]),
                                                      _: 1
                                                    })
                                                  ]),
                                                  _: 1
                                                }),
                                                _createVNode(_component_v_sheet, {
                                                  color: "transparent",
                                                  height: "40",
                                                  class: "rowName"
                                                }, {
                                                  default: _withCtx(() => [
                                                    _createElementVNode("span", null, _toDisplayString(_unref(t)("checkBoxes.showAll")), 1)
                                                  ]),
                                                  _: 1
                                                }),
                                                _createVNode(_component_v_checkbox, {
                                                  modelValue: showALL.value,
                                                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((showALL).value = $event)),
                                                  color: "success",
                                                  "hide-details": ""
                                                }, null, 8, ["modelValue"])
                                              ]),
                                              _: 1
                                            }),
                                            (showALL.value)
                                              ? (_openBlock(), _createElementBlock("span", _hoisted_1, [
                                                  _createVNode(_component_v_row, { class: "ma-0 my-2" }, {
                                                    default: _withCtx(() => [
                                                      _createVNode(_component_v_sheet, {
                                                        class: "rowIcon",
                                                        color: "transparent",
                                                        height: "40",
                                                        width: "40"
                                                      }, {
                                                        default: _withCtx(() => [
                                                          _createElementVNode("img", {
                                                            height: '25',
                                                            src: _unref(CONSTANTIMGS).IMAGES.onlyap
                                                          }, null, 8, _hoisted_2)
                                                        ]),
                                                        _: 1
                                                      }),
                                                      _createVNode(_component_v_sheet, {
                                                        color: "transparent",
                                                        height: "40",
                                                        class: "rowName"
                                                      }, {
                                                        default: _withCtx(() => [
                                                          _createElementVNode("span", null, _toDisplayString(_unref(t)("checkBoxes.showPMPAP")), 1)
                                                        ]),
                                                        _: 1
                                                      }),
                                                      _createVNode(_component_v_checkbox, {
                                                        modelValue: showPMPAP.value,
                                                        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((showPMPAP).value = $event)),
                                                        color: "success",
                                                        "hide-details": ""
                                                      }, null, 8, ["modelValue"])
                                                    ]),
                                                    _: 1
                                                  }),
                                                  _createVNode(_component_v_row, { class: "ma-0 my-2" }, {
                                                    default: _withCtx(() => [
                                                      _createVNode(_component_v_sheet, {
                                                        class: "rowIcon",
                                                        color: "transparent",
                                                        height: "40",
                                                        width: "40"
                                                      }, {
                                                        default: _withCtx(() => [
                                                          _createElementVNode("img", {
                                                            height: '25',
                                                            src: _unref(CONSTANTIMGS).IMAGES.onlypmp
                                                          }, null, 8, _hoisted_3)
                                                        ]),
                                                        _: 1
                                                      }),
                                                      _createVNode(_component_v_sheet, {
                                                        color: "transparent",
                                                        height: "40",
                                                        class: "rowName"
                                                      }, {
                                                        default: _withCtx(() => [
                                                          _createElementVNode("span", null, _toDisplayString(_unref(t)("checkBoxes.showPMPSM")), 1)
                                                        ]),
                                                        _: 1
                                                      }),
                                                      _createVNode(_component_v_checkbox, {
                                                        modelValue: showPMPSM.value,
                                                        "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((showPMPSM).value = $event)),
                                                        color: "success",
                                                        "hide-details": ""
                                                      }, null, 8, ["modelValue"])
                                                    ]),
                                                    _: 1
                                                  }),
                                                  _createVNode(_component_v_row, { class: "ma-0 my-2" }, {
                                                    default: _withCtx(() => [
                                                      _createVNode(_component_v_sheet, {
                                                        class: "rowIcon",
                                                        color: "transparent",
                                                        height: "40",
                                                        width: "40"
                                                      }, {
                                                        default: _withCtx(() => [
                                                          _createElementVNode("img", {
                                                            height: '25',
                                                            src: _unref(CONSTANTIMGS).IMAGES.onlysolar
                                                          }, null, 8, _hoisted_4)
                                                        ]),
                                                        _: 1
                                                      }),
                                                      _createVNode(_component_v_sheet, {
                                                        color: "transparent",
                                                        height: "40",
                                                        class: "rowName"
                                                      }, {
                                                        default: _withCtx(() => [
                                                          _createElementVNode("span", null, _toDisplayString(_unref(t)("checkBoxes.ShowRajant")), 1)
                                                        ]),
                                                        _: 1
                                                      }),
                                                      _createVNode(_component_v_checkbox, {
                                                        modelValue: showRajant.value,
                                                        "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((showRajant).value = $event)),
                                                        color: "success",
                                                        "hide-details": ""
                                                      }, null, 8, ["modelValue"])
                                                    ]),
                                                    _: 1
                                                  }),
                                                  _createVNode(_component_v_row, { class: "ma-0 my-2" }, {
                                                    default: _withCtx(() => [
                                                      _createVNode(_component_v_sheet, {
                                                        class: "rowIcon",
                                                        color: "transparent",
                                                        height: "40",
                                                        width: "40"
                                                      }, {
                                                        default: _withCtx(() => [
                                                          _createElementVNode("img", {
                                                            height: '25',
                                                            src: _unref(CONSTANTIMGS).ICONS.links
                                                          }, null, 8, _hoisted_5)
                                                        ]),
                                                        _: 1
                                                      }),
                                                      _createVNode(_component_v_sheet, {
                                                        color: "transparent",
                                                        height: "40",
                                                        class: "rowName"
                                                      }, {
                                                        default: _withCtx(() => [
                                                          _createElementVNode("span", null, _toDisplayString(_unref(t)("checkBoxes.showLink")), 1)
                                                        ]),
                                                        _: 1
                                                      }),
                                                      _createVNode(_component_v_checkbox, {
                                                        modelValue: showPolilynesBoolean.value,
                                                        "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((showPolilynesBoolean).value = $event)),
                                                        color: "success",
                                                        "hide-details": ""
                                                      }, null, 8, ["modelValue"])
                                                    ]),
                                                    _: 1
                                                  }),
                                                  _createVNode(_component_v_row, { class: "ma-0 my-2" }, {
                                                    default: _withCtx(() => [
                                                      _createVNode(_component_v_sheet, {
                                                        class: "rowIcon pl-2 pt-0",
                                                        color: "transparent",
                                                        height: "40",
                                                        width: "40"
                                                      }, {
                                                        default: _withCtx(() => [
                                                          _createVNode(_component_v_sheet, {
                                                            class: "sheetNameIcon",
                                                            width: "25",
                                                            height: "25"
                                                          }, {
                                                            default: _withCtx(() => [...(_cache[13] || (_cache[13] = [
                                                              _createElementVNode("span", { class: "nameClassIcon" }, "N", -1)
                                                            ]))]),
                                                            _: 1
                                                          })
                                                        ]),
                                                        _: 1
                                                      }),
                                                      _createVNode(_component_v_sheet, {
                                                        color: "transparent",
                                                        height: "40",
                                                        class: "rowName"
                                                      }, {
                                                        default: _withCtx(() => [
                                                          _createElementVNode("span", null, _toDisplayString(_unref(t)("checkBoxes.showNames")), 1)
                                                        ]),
                                                        _: 1
                                                      }),
                                                      _createVNode(_component_v_checkbox, {
                                                        modelValue: showNames.value,
                                                        "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((showNames).value = $event)),
                                                        color: "success",
                                                        "hide-details": ""
                                                      }, null, 8, ["modelValue"])
                                                    ]),
                                                    _: 1
                                                  })
                                                ]))
                                              : _createCommentVNode("", true),
                                            _createVNode(_component_v_row, { class: "ma-0 my-2" }, {
                                              default: _withCtx(() => [
                                                _createVNode(_component_v_sheet, {
                                                  class: "rowIcon",
                                                  color: "transparent",
                                                  height: "40",
                                                  width: "40"
                                                }, {
                                                  default: _withCtx(() => [
                                                    _createElementVNode("img", {
                                                      height: '25',
                                                      src: _unref(CONSTANTIMGS).ICONS.circles
                                                    }, null, 8, _hoisted_6)
                                                  ]),
                                                  _: 1
                                                }),
                                                _createVNode(_component_v_sheet, {
                                                  color: "transparent",
                                                  height: "40",
                                                  class: "rowName"
                                                }, {
                                                  default: _withCtx(() => [...(_cache[14] || (_cache[14] = [
                                                    _createElementVNode("span", null, "Clusters", -1)
                                                  ]))]),
                                                  _: 1
                                                }),
                                                _createVNode(_component_v_checkbox, {
                                                  modelValue: showCircleCluster.value,
                                                  "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((showCircleCluster).value = $event)),
                                                  color: "success",
                                                  "hide-details": ""
                                                }, null, 8, ["modelValue"])
                                              ]),
                                              _: 1
                                            })
                                          ]),
                                          _: 1
                                        })
                                      ]),
                                      _: 1
                                    }))
                                  : (_openBlock(), _createBlock(_component_v_row, {
                                      key: 1,
                                      class: "ma-0 mb-3"
                                    }, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_v_col, {
                                          class: "pa-0",
                                          cols: "12",
                                          sm: "4",
                                          md: "12"
                                        }, {
                                          default: _withCtx(() => [
                                            _createVNode(_component_v_checkbox, {
                                              modelValue: showNames.value,
                                              "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((showNames).value = $event)),
                                              color: "success",
                                              label: _unref(t)('checkBoxes.showNames'),
                                              "hide-details": ""
                                            }, null, 8, ["modelValue", "label"])
                                          ]),
                                          _: 1
                                        })
                                      ]),
                                      _: 1
                                    }))
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }),
                    _createVNode(_unref(LTileLayer), { url: finalURL.value }, null, 8, ["url"]),
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(activePolylines.value, (line, idx) => {
                      return (_openBlock(), _createBlock(_unref(LPolyline), {
                        key: 'poly-' + idx,
                        "lat-lngs": line.path,
                        color: line.colorLine,
                        weight: 3,
                        opacity: 0.8
                      }, null, 8, ["lat-lngs", "color"]))
                    }), 128)),
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(renderClusters.value, (cluster) => {
                      return (_openBlock(), _createBlock(_unref(LMarker), {
                        key: cluster.id,
                        "lat-lng": cluster.position
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_unref(LIcon), {
                            "icon-size": [60, 60],
                            "icon-anchor": [35, 30]
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_v_sheet, {
                                color: "transparent",
                                width: 70,
                                class: "text-center"
                              }, {
                                default: _withCtx(() => [
                                  _createElementVNode("img", {
                                    height: '30',
                                    src: cluster.compositeImage
                                  }, null, 8, _hoisted_7),
                                  (showNames.value)
                                    ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(cluster.devices, (dev) => {
                                        return (_openBlock(), _createBlock(_component_v_sheet, {
                                          key: 'name-' + dev.ip,
                                          class: _normalizeClass('classnameIcon mb-1 ' + getColorCard(dev.status)),
                                          onClick: _withModifiers(($event: any) => (onDeviceClick(dev)), ["stop"])
                                        }, {
                                          default: _withCtx(() => [
                                            _createElementVNode("h5", null, _toDisplayString(dev.name), 1)
                                          ]),
                                          _: 2
                                        }, 1032, ["class", "onClick"]))
                                      }), 128))
                                    : _createCommentVNode("", true)
                                ]),
                                _: 2
                              }, 1024)
                            ]),
                            _: 2
                          }, 1024),
                          _createVNode(_unref(LTooltip), { options: {
                  permanent: false,
                  interactive: true,
                  direction: 'right',
                } }, {
                            default: _withCtx(() => [
                              _createVNode(_component_v_sheet, {
                                class: "sheetTooltip text-center",
                                color: "#9fa09f",
                                "min-width": widthToolTip.value
                              }, {
                                default: _withCtx(() => [
                                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(cluster.devices, (dev, dIdx) => {
                                    return (_openBlock(), _createElementBlock("div", {
                                      key: 'tooltip-' + dev.ip,
                                      class: "pa-1"
                                    }, [
                                      _createVNode(_component_v_sheet, {
                                        color: getColorSheet(dev.status),
                                        class: "text-caption font-weight-bold px-1"
                                      }, {
                                        default: _withCtx(() => [
                                          _createTextVNode(_toDisplayString(dev.name) + " (" + _toDisplayString(dev.tipo) + ") ", 1)
                                        ]),
                                        _: 2
                                      }, 1032, ["color"]),
                                      _createElementVNode("div", {
                                        innerHTML: getInfoInToMap(dev.ip)
                                      }, null, 8, _hoisted_8),
                                      (dIdx < cluster.devices.length - 1)
                                        ? (_openBlock(), _createBlock(_component_v_divider, {
                                            key: 0,
                                            class: "my-1",
                                            color: "white"
                                          }))
                                        : _createCommentVNode("", true)
                                    ]))
                                  }), 128))
                                ]),
                                _: 2
                              }, 1032, ["min-width"])
                            ]),
                            _: 2
                          }, 1024)
                        ]),
                        _: 2
                      }, 1032, ["lat-lng"]))
                    }), 128))
                  ]),
                  _: 1
                }, 8, ["style", "zoom", "center"]),
                (!active.value)
                  ? (_openBlock(), _createBlock(_component_v_sheet, {
                      key: 0,
                      class: "mapTest"
                    }))
                  : _createCommentVNode("", true)
              ])), [
                [_directive_click_outside, { handler: onClickOutside }]
              ]),
              _createVNode(_component_v_sheet, {
                class: "mt-5",
                width: "100%",
                color: "transparent",
                style: {"align-content":"center"}
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_row, {
                    class: "ma-0",
                    justify: _unref(smAndDown) ? 'center' : 'space-between'
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_sheet, {
                        color: "transparent",
                        width: _unref(mdAndDown) ? '100%' : 360
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_v_row, {
                            class: "ma-0",
                            justify: _unref(mdAndDown) ? 'center' : 'start'
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_v_icon, null, {
                                default: _withCtx(() => [...(_cache[15] || (_cache[15] = [
                                  _createTextVNode(" mdi-speedometer ", -1)
                                ]))]),
                                _: 1
                              }),
                              _createElementVNode("span", _hoisted_9, [
                                _createTextVNode(_toDisplayString(_unref(t)("labels.latency")) + " | ", 1),
                                _createElementVNode("span", null, _toDisplayString(_unref(t)("labels.redSpeed")), 1)
                              ])
                            ]),
                            _: 1
                          }, 8, ["justify"])
                        ]),
                        _: 1
                      }, 8, ["width"]),
                      _createVNode(rangeComponent, {
                        class: _normalizeClass(_unref(smAndDown) ? 'mt-2' : 'mt-0'),
                        "principal-color": _unref(COLOR).green,
                        "secundary-color": 'rgb(62 97 57)',
                        "color-text-princ": 'white',
                        "color-text-secun": 'white',
                        "principal-text": _unref(t)('labels.ok'),
                        "secundary-text": '0 a 100 ms',
                        sheetWidth: _unref(smAndDown) ? 350 : 225
                      }, null, 8, ["class", "principal-color", "principal-text", "sheetWidth"]),
                      _createVNode(rangeComponent, {
                        class: _normalizeClass(_unref(smAndDown) ? 'mt-2' : 'mt-0'),
                        "principal-color": _unref(COLOR).yellow,
                        "secundary-color": '#B4A343',
                        "color-text-princ": 'black',
                        "color-text-secun": 'white',
                        "principal-text": _unref(t)('labels.alert'),
                        "secundary-text": '100 a 500 ms',
                        sheetWidth: _unref(smAndDown) ? 350 : 225
                      }, null, 8, ["class", "principal-color", "principal-text", "sheetWidth"]),
                      _createVNode(rangeComponent, {
                        class: _normalizeClass(_unref(smAndDown) ? 'mt-2' : 'mt-0'),
                        "principal-color": _unref(COLOR).red,
                        "secundary-color": '#8F3A36',
                        "color-text-princ": 'white',
                        "color-text-secun": 'white',
                        "principal-text": _unref(t)('labels.alarm'),
                        "secundary-text": 'Mayor a 500 ms',
                        sheetWidth: _unref(smAndDown) ? 350 : 225
                      }, null, 8, ["class", "principal-color", "principal-text", "sheetWidth"])
                    ]),
                    _: 1
                  }, 8, ["justify"])
                ]),
                _: 1
              })
            ], 4),
            (showFilters.value)
              ? (_openBlock(), _createBlock(_component_v_sheet, {
                  key: 0,
                  color: "transparent",
                  class: _normalizeClass(_unref(mdAndDown) ? 'pa-0 pt-4' : 'pl-4'),
                  style: _normalizeStyle(_unref(mdAndDown) ? 'text-align: -webkit-center;' : ''),
                  width: _unref(mdAndDown) ? '100%' : width.value
                }, {
                  default: _withCtx(() => [
                    _createVNode(MessageComponent, { "recurrent-alarms": __props.recurrentAlarms }, null, 8, ["recurrent-alarms"])
                  ]),
                  _: 1
                }, 8, ["class", "style", "width"]))
              : _createCommentVNode("", true)
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    _createVNode(_component_v_dialog, {
      modelValue: dialog.value,
      "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((dialog).value = $event)),
      width: "85%"
    }, {
      default: _withCtx(() => [
        (dialog.value)
          ? (_openBlock(), _createBlock(DialogComponent, {
              key: 0,
              ip: selectedIp.value,
              typeSel: selectedType.value,
              name: selectedName.value,
              status: finalStatus.value,
              onDialog: closeDialog
            }, null, 8, ["ip", "typeSel", "name", "status"]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }, 8, ["modelValue"])
  ], 64))
}
}

})